import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import { useSelector } from "react-redux";
import moment from "moment";
import { Spin } from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../../reports/colors";

const DiamondReportsClarityComp = ({
  globalDiamonds,
  isApplyFilter,
  mainForDealer,
}) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const loginDetials = useSelector((state) => state.loginReducer);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [diamondClaritySearchesLabels, setdiamondClaritySearchesLabels] =
    useState([]);
  const [DiamondClaritySearchesList, setDiamondClaritySearchesList] = useState(
    []
  );
  const [DiamondClarityYAxisList, setDiamondClarityYAxisList] = useState([]);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [key, setKey] = useState(true);

  // New states for processed chart data
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum entries to show
  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          handleLoadExtendedDiamondChartReports(
            loginDetials.loginDetials.responseData.dealerId,
            mainForDealer
          );
        }
      }
    }
  }, [isApplyFilter]);

  // Process chart data with max entries limit
  const processChartData = (searchesList) => {
    if (!searchesList?.length) {
      return { chartData: [], colors: [] };
    }

    // Filter out zero values and sort by count (descending)
    const filteredData = searchesList.filter((item) => item.CNT > 0);
    const sortedData = [...filteredData].sort((a, b) => b.CNT - a.CNT);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.CNT, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        Clarity: t("Others"),
        CNT: othersValue,
        isOthers: true,
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.CNT, 0);

    // Prepare chart data
    const processedChartData = [["Clarity", "Count"]];
    const colors = [];

    topData.forEach((item, index) => {
      const percentage = total > 0 ? ((item.CNT / total) * 100).toFixed(1) : 0;
      const color = item.isOthers
        ? "#CCCCCC"
        : chartColors[index % chartColors.length];
      colors.push(color);

      processedChartData.push([`${item.Clarity} (${percentage}%)`, item.CNT]);
    });

    return { chartData: processedChartData, colors };
  };

  /*API Binding Starts*/
  const handleLoadExtendedDiamondChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);
      ReportsDiamondService.LoadExtendedDiamondChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondClaritySearchesList = responseData.DiamondClaritySearches;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setDiamondClaritySearchesList(DiamondClaritySearchesList);
              var DiamondClaritySearchesLabelArr =
                DiamondClaritySearchesList.map((item) => {
                  return item.Clarity;
                });
              setdiamondClaritySearchesLabels(DiamondClaritySearchesLabelArr);
              var DiamondClarityYAxisList = DiamondClaritySearchesList.map(
                (item) => {
                  return item.CNT;
                }
              );
              setDiamondClarityYAxisList(DiamondClarityYAxisList);
              var totalValueForPercentage = DiamondClarityYAxisList.reduce(
                (a, b) => a + b,
                0
              );

              setTotalValueForPercentage(totalValueForPercentage);

              // Process data with max entries limit
              const { chartData: processedData, colors } = processChartData(
                DiamondClaritySearchesList
              );
              setChartData(processedData);
              setColorData(colors);

              setKey(!key);
            }
          } else {
            setDiamondClaritySearchesList([]);
            setDiamondClarityYAxisList([]);
            setChartData([]);
            setColorData([]);
          }
        })
        .catch((error) => {
          setDiamondClaritySearchesList([]);
          setDiamondClarityYAxisList([]);
          setChartData([]);
          setColorData([]);
          setLoadChartReportsLoading(false);
          setdiamondClaritySearchesLabels([]);
        });
    } catch (error) {
      setDiamondClaritySearchesList([]);
      setDiamondClarityYAxisList([]);
      setChartData([]);
      setColorData([]);
      setLoadChartReportsLoading(false);
      setdiamondClaritySearchesLabels([]);
    }
  };
  /*API Binding Ends*/

  const options = {
    pieHole: 0,
    is3D: true,
    legend: {
      position: "none",
    },
    chartArea: {
      width: "100%",
      height: "100%",
      left: window.innerWidth > 500 ? 50 : 10,
      top: 50,
      bottom: 50,
    },
    pieSliceText: "percentage",
    tooltip: {
      trigger: "focus",
      text: "both",
    },
    colors: colorData,
  };

  // Custom Legend Component
  const CustomLegend = () => {
    if (!chartData.length || chartData.length <= 1) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        {chartData.slice(1).map((row, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              margin: "4px 8px",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                width: "14px",
                height: "14px",
                backgroundColor: colorData[index],
                marginRight: "6px",
                borderRadius: "3px",
              }}
            ></div>
            {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
          </div>
        ))}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b> {t("Diamond Clarity Searches")} </b>
        </label>
        <div
          className="chart__section"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Spin spinning={LoadChartReportsLoading} size="large">
            {chartData.length > 1 ? (
              <>
                {/* Custom Legend */}
                <CustomLegend />

                {/* Centered Pie Chart */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Chart
                    chartType="PieChart"
                    data={chartData}
                    options={options}
                    width={window.innerWidth > 500 ? 800 : 320}
                    height={window.innerWidth > 500 ? 500 : 320}
                  />
                </div>
              </>
            ) : (
              <div className="no-report-render">
                <div className="desc-space">
                  <h4 className="text-center">{t("No Data Found")}</h4>
                </div>
              </div>
            )}
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsClarityComp;
